module.exports = __webpack_public_path__ + "staticcomp/img/content_1.c82385b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/content_1.jpg
// module id = KEUx
// module chunks = 39